import { CONFIG_STORAGE_KEY } from "../common/constants";
import { checkIsEmbededEnvironment } from "./functions";

 export const updateLocaleStorageHandler = (currentConfig: WidgetConfig, widgetId: string) => {
    const storageResult = localStorage.getItem(CONFIG_STORAGE_KEY);
    const storageConfig = JSON.parse(storageResult ?? '{}');
    if (storageConfig) {
      const updatedConfig = {
        ...storageConfig,
        [widgetId]: {
          ...currentConfig,
        }
      };
      localStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(updatedConfig));
    } else {
      const newConfig = {
        [widgetId]: {
          ...currentConfig, 
        }
      };
      localStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(newConfig));
    }
}

export const getLocaleStorageConfigById = (widgetId: string): WidgetConfig | null => {
    const storageResult = localStorage.getItem(CONFIG_STORAGE_KEY);
    const storageConfig = JSON.parse(storageResult ?? '{}');
    if (storageConfig && storageConfig[widgetId]) {
      return storageConfig[widgetId];
    }
    return null;
}

export const getEmbedWidgetConfig = (widgetId: string): WidgetConfig | null => {
    const storageResult = localStorage.getItem(widgetId);
    const storageConfig = storageResult ? JSON.parse(storageResult) : null;
    return storageConfig;
}

export const updateEmbedWidgetConfig = (defaultConfig: WidgetConfig, key: string, newValue: any) => {
  const isEmbedEnv = checkIsEmbededEnvironment();
  console.log('isEmbedEnv---', isEmbedEnv);
  if(isEmbedEnv) {
    const widgetId = defaultConfig.widgetId;
    const storageResult = localStorage.getItem(widgetId);
    const storageConfig = storageResult ? JSON.parse(storageResult) : defaultConfig;
    const updatedConfig = {
      ...storageConfig, 
      [key]: newValue,
    };
    localStorage.setItem(widgetId, JSON.stringify(updatedConfig));
  } 
}
